import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/section/styles.scss';export default {
  "header": "_header_18upv_1",
  "iconBox": "_iconBox_18upv_10",
  "icon": "_icon_18upv_10",
  "open": "_open_18upv_28"
};